import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote1 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>Explainability and Accountability in Deep Few-Shot Learning: A Case Study in Medical Imaging Informatics</b> <br/>
            <br /> Dr. Ahmad P. Tafti <br/>
            Faculty, Health Informatics, University of Pittsburgh, USA and<br />
            Director, Pitt Health + Explainable AI (Pitt HexAI) <br />
            Vice Chair, IEEE Computer Society at Pittsburgh<br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            Of late, deep learning computer vision algorithms have played as state-of-the-art strategies for a list of medical image analysis tasks, ranging from medical image segmentation and registration to image classification. However, there are several fundamental challenges that stop deep learning methods to obtain their full potential in healthcare domain. One can see that they often need a large column of labeled training data to achieve better accuracy and precision over traditional ML methods. This could lead to a list of problems in clinical settings, including but not limited to: 1) Annotating medical data/images requires significant medical knowledge which makes the annotation process expensive and very time consuming, 2) Providing a large amount of annotated/labeled data in a clinical setting is basically challenging due to high privacy-preserving standards in healthcare community, and 3) Medical images are often imperfect due to heterogeneity in medical imaging devices and equipment. In this talk, we will see how to build, train, test, and validate an explainable and accountable deep few-shot learning model to analyze medical images with only very few samples of manually annotated radiographs.
            </div>

            <h6 className="par_header">Speaker’s Biography:</h6>
            <div className="par">
            Ahmad P. Tafti is an Assistant Professor of Health Informatics at the University of Pittsburgh, where he is leading the <a href="https://pitthexai.github.io/" target="_blank" rel="noopener noreferrer">Pitt HexAI Research Laboratory</a>. Dr. Tafti received his PhD in computer science with an emphasis on artificial intelligence and 3D computer vision. Dr. Tafti is serving our community as the Vice Chair of IEEE Computer Society at Pittsburgh, and he is passionate about AI and its applications in healthcare. Ahmad P. Tafti is the 2021 SiiM Imaging Informatics Innovator awardee, Mayo Clinic Benefactor funded CDAs Orthopedics Career Development awardee, Mayo Clinic Transform the Practice awardee, an NVIDIA GPU awardee, and GE Healthcare Honorable Mention awardee. To date, he has authored 45+ peer-reviewed publications, organizing numerous workshops on intelligent health systems and I have served on the program committee of 15+ conferences, symposiums, and journals in AI and health data science.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/tafti2.png" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote1;